/**
 * How an image or a stage takes its height from its width.
 *
 * Today's layout items cannot keep an aspect, so the height is written from the width the block is known to get at build time. This
 * is the one Fixed axis below a unit, and it does not follow a resize. (A Hug-height stage does not work either: the slot measures
 * its content before the fit scales it, so the content overflows a height that stayed at its natural size.) When the engine's item `aspectRatio` lands (Layout quality
 * 3/7), return `{ aspectRatio: aspect, heightMode: 'Hug' }` here and nothing else changes.
 */
export function aspectItemSizing(widthM: number, aspect: number): { heightMode: 'Fixed'; height: number } {
    return { heightMode: 'Fixed', height: Math.round(widthM / aspect * 1e6) / 1e6 };
}
